import { createStyles } from '@mantine/core';
import themeVariables from '@/styles/themeVariables';

export const createArchitectureListPageStyle = createStyles((theme) => ({
  sidePanelContainer: {
    [theme.fn.largerThan('lg')]: {
      maxWidth: 440,
    },
  },
}));

export const useArchitectureCardStyle = createStyles((_, dark: any) => ({
  cardContainer: {},

  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 18,
  },

  headerCompanyLogo: {
    borderRadius: '0.5rem',
  },

  headerCompanyTitle: {
    fontWeight: 500,
    fontSize: 15,
    color: dark?.dark
      ? themeVariables.label.normalDark
      : themeVariables.label.normal,
  },

  appHeaderCompanyTitle: {
    fontWeight: 500,
    fontSize: 11,
    color: themeVariables.fontColors.extraLight,
  },

  img: {
    height: 'fit-content !important',
    maxHeight: 200,
    width: '100%',
    objectFit: 'contain',
    margin: 'auto',
    borderRadius: 14,
  },

  appImg: {
    borderRadius: 10,
    width: '100%',
    minHeight: 120,
    objectFit: 'cover',
    border: `0.5px solid ${themeVariables.colors.light300}`,
  },

  title: {
    fontSize: 18,
    fontWeight: 600,
    color: dark?.dark
      ? themeVariables.label.normalDark
      : themeVariables.fontColors.dark,
    lineHeight: '1.8',
    marginTop: 18,
    height: 56,
    overflow: 'hidden',
  },

  appTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: themeVariables.fontColors.dark,
    lineHeight: 1.4,
  },

  avatarGroupContainer: {
    padding: '12px 0px',
  },

  appAvatarGroupContainer: {
    marginTop: 5,
    position: 'absolute',
    bottom: 5,
    right: 5,
    backgroundColor: 'rgb(0, 0, 0, 0.5)',
    borderRadius: '1rem',
    padding: 2,
  },

  emptyAvatarGroupContainer: {
    height: 50,
    display: 'flex',
    fontSize: 14,
    color: dark?.dark
      ? themeVariables.label.alternativeDark
      : themeVariables.fontColors.light,
    alignItems: 'center',
  },

  tagGroupContainer: {
    display: 'flex',
    gap: 4,
    padding: '12px 0px 6px',
  },
}));

export const useArchitectureListPageSideBoxStyle = createStyles(
  (theme, dark: any) => ({
    rankingContainer: {
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },

    cardContainer: {
      padding: 4,
      [theme.fn.smallerThan('sm')]: {
        padding: 0,
      },
    },

    headerContainer: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      columnGap: 15,
      padding: '12px 6px',
      justifyContent: 'space-between',
      marginBottom: 5,
    },

    headerTitleImage: {
      width: 24,
      height: 24,
    },

    headerTitle: {
      fontWeight: 600,
      fontSize: 16,
    },

    headerArrow: {
      marginLeft: 'auto',
      '& svg': {
        verticalAlign: 'middle',
      },
    },

    searchBoxContainer: {
      padding: '12px 0px',
    },

    searchBoxFilterTagTitle: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 8,
      columnGap: 8,
      fontSize: 14,
      fontWeight: 600,
      color: dark?.dark
        ? themeVariables.label.normalDark
        : themeVariables.fontColors.light,
    },

    searchBoxFilterTagContainer: {
      marginTop: 20,
      padding: 10,
      borderRadius: '0.75rem',
      backgroundColor: dark?.dark
        ? 'transparent'
        : themeVariables.colors.light000,
      display: 'flex',
      gap: 6,
      flexWrap: 'wrap',
    },

    searchBoxnoFilterContainer: {
      display: 'flex',
      alignItems: 'center',
      placeContent: 'center',
      padding: '30px 0px 15px',
      gap: 8,
      fontSize: 14,
      color: themeVariables.fontColors.extraLight,
    },

    searchBoxTechstackIdsTabButtonContainer: {
      display: 'flex',
      marginTop: 12,
      placeContent: 'flex-end',
      columnGap: 4,
    },

    searchBoxCategoryTabButtonContainer: {
      display: 'flex',
      marginTop: 12,
      placeContent: 'flex-end',
      columnGap: 4,
    },

    popularRankingListContainer: {
      padding: '12px 0px',
    },

    tabContainer: {
      marginBottom: 16,
    },

    tab: {
      color: dark?.dark
        ? themeVariables.label.normalDark
        : themeVariables.fontColors.light,
      '&[data-active]': {
        color: '#0064fa',
        backgroundColor: '#eaf5ff',
        fontWeight: 500,
        '&:hover': {
          color: '#0064fa',
          backgroundColor: '#eaf5ff',
          fontWeight: 500,
        },
      },
    },
  })
);

export const createArchitectureDetailPageStyles = createStyles((theme) => ({
  detailCardContainer: {
    [theme.fn.largerThan('md')]: {
      maxWidth: 900,
    },
  },

  cardContainer: {
    padding: 24,
    [theme.fn.smallerThan('sm')]: {
      padding: 0,
    },
  },

  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    letterSpacing: '-0.05em',
  },

  headerLogo: {
    width: 52,
    height: 52,
    borderRadius: '0.5rem',
  },

  appHeaderLogo: {
    borderRadius: '0.5rem',
    border: `0.5px solid ${themeVariables.colors.light300}`,
  },

  desktopShareButtonsContainer: {
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },

  mobileShareButtonsContainer: {
    display: 'flex',
    padding: '32px 0px 16px',
    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },

  mobileShareButtonsBackground: {
    margin: 'auto',
    backgroundColor: themeVariables.colors.light000,
    padding: 8,
    borderRadius: 30,
  },

  headerTitle: {
    fontSize: 24,
    fontWeight: 600,
    padding: '20px 0px',
    [theme.fn.smallerThan('sm')]: {
      fontSize: 21,
      padding: '20px 0px 12px',
    },
  },

  appHeaderTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: themeVariables.fontColors.dark,
  },

  headerSubtitle: {
    fontSize: 14,
    fontWeight: 400,
  },

  appHeaderSubtitle: {
    fontSize: 12,
    color: themeVariables.fontColors.extraLight,
  },

  headerServiceCategoryContainer: {
    display: 'flex',
    gap: 6,
    padding: '18px 0px 6px',
  },

  appHeaderServiceCategoryContainer: {
    display: 'flex',
    gap: 6,
    padding: '5px 0px 10px',
  },

  headerBookmarkButton: {
    cursor: 'pointer',
    margin: '0px 8px 0px auto',
  },

  bodyContainer: {
    padding: '10px 10px 80px 10px',
    [theme.fn.smallerThan('sm')]: {
      padding: '10px 2px 40px 2px',
    },
  },

  appBodyContainer: {
    padding: '10px 0px 40px ',
  },

  bodyTechstackAvatarGroupContainer: {
    margin: '8px 0px',
    padding: '12px 12px',
    borderRadius: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 10,
    fontSize: 14,
    fontWeight: 600,
  },

  appBodyTechstackAvatarGroupContainer: {
    marginBottom: 6,
    padding: '4px 12px',
    borderRadius: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 10,
    fontSize: 14,
    color: themeVariables.fontColors.light,
    fontWeight: 600,
    border: `1px solid ${themeVariables.colors.light300}`,
  },

  bodyTechstackNoResultText: {
    fontSize: 14,
    fontWeight: 400,
  },

  blurBackgroundContainer: {
    position: 'relative',
  },

  bodyImage: {
    width: '100%',
    padding: '60px 12px',
    maxHeight: 500,
  },

  appBodyImage: {
    width: '100%',
    maxHeight: 500,
    margin: '10px 0px 15px',
  },

  bodyHTML: {
    fontSize: 15,
    lineHeight: 2,
  },

  appBodyHTML: {
    fontSize: 15,
    lineHeight: 1.5,
    color: themeVariables.fontColors.medium,
    width: '100%',
  },

  bodyVideoContainer: {
    padding: '40px 0px',
    '& iframe': {
      width: '100%',
      height: 400,
      borderRadius: 16,

      [theme.fn.smallerThan('sm')]: {
        height: 240,
      },
    },
  },

  appBodyVideoContainer: {
    '& iframe': {
      width: '100%',
      height: 240,
      borderRadius: 16,
    },
    marginTop: 20,
  },

  commentTitle: {
    fontSize: 16,
    fontWeight: 600,
  },

  commentNoResultContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 0px',
    alignItems: 'center',
    color: themeVariables.fontColors.extraLight,
    gap: 16,
    fontSize: 14,
  },

  commentNoResultAnimation: {
    width: 60,
  },

  addCommentContainer: {},

  addCommentTitle: {
    fontSize: 16,
    fontWeight: 600,
    margin: '40px 0px 20px',
  },

  addCommentButtonContainer: {
    textAlign: 'end',
    margin: '8px 0px',
  },

  blurBackground: {
    position: 'absolute',
    height: '105%',
    width: '105%',
    top: -4,
    left: -10,
    zIndex: 2,
    backdropFilter: 'blur(9px);',
  },

  blurButton: {
    position: 'absolute',
    left: '50%',
    zIndex: 3,
    transform: 'translate(-50%, 150%)',
  },
}));
